// Purchase credit "Source" — who is giving the credit. Mirrors POINT's Source
// dropdown in Section 2b and maps 1:1 to the MISMO PurchaseCreditSourceType
// enum. Used on the Adjustments & Other Credits subpage for the generic/other
// credits (the named credits derive their source automatically on export).
//
// A blank value ("") shows the SelectField's "Select..." placeholder.

export const BORROWER_PAID_OUTSIDE_CLOSING = "borrower_poc";
export const BUILDER_DEVELOPER = "builder_developer";
export const EMPLOYER = "employer";
export const FEDERAL_AGENCY = "federal_agency";
export const LENDER = "lender";
export const LOCAL_AGENCY = "local_agency";
export const NON_PARENT_RELATIVE = "non_parent_relative";
export const PARENT = "parent";
export const PROPERTY_SELLER = "property_seller";
export const REAL_ESTATE_AGENT = "real_estate_agent";
export const STATE_AGENCY = "state_agency";
export const UNRELATED_FRIEND = "unrelated_friend";
export const OTHER_SOURCE = "other";

export const PURCHASE_CREDIT_SOURCES = Object.freeze({
  [BORROWER_PAID_OUTSIDE_CLOSING]: "Borrower Paid Outside Closing",
  [BUILDER_DEVELOPER]: "Builder / Developer",
  [EMPLOYER]: "Employer",
  [FEDERAL_AGENCY]: "Federal Agency",
  [LENDER]: "Lender",
  [LOCAL_AGENCY]: "Local Agency",
  [NON_PARENT_RELATIVE]: "Non-Parent Relative",
  [PARENT]: "Parent",
  [PROPERTY_SELLER]: "Property Seller",
  [REAL_ESTATE_AGENT]: "Real Estate Agent",
  [STATE_AGENCY]: "State Agency",
  [UNRELATED_FRIEND]: "Unrelated Friend",
  [OTHER_SOURCE]: "Other"
});

export const SOURCE_TO_MISMO = Object.freeze({
  [BORROWER_PAID_OUTSIDE_CLOSING]: "BorrowerPaidOutsideClosing",
  [BUILDER_DEVELOPER]: "BuilderDeveloper",
  [EMPLOYER]: "Employer",
  [FEDERAL_AGENCY]: "FederalAgency",
  [LENDER]: "Lender",
  [LOCAL_AGENCY]: "LocalAgency",
  [NON_PARENT_RELATIVE]: "NonParentRelative",
  [PARENT]: "Parent",
  [PROPERTY_SELLER]: "PropertySeller",
  [REAL_ESTATE_AGENT]: "RealEstateAgent",
  [STATE_AGENCY]: "StateAgency",
  [UNRELATED_FRIEND]: "UnrelatedFriend",
  [OTHER_SOURCE]: "Other"
});
